// extracted by mini-css-extract-plugin
module.exports =  {"tc-loader":"Loader-module__tc-loader___B05pj"};